let index;

const driverService = {
	getIndex: () => index,
	setIndex: (id) => (index = id),
};

export default driverService;
